import React from "react";

import xmarkIcon from "../assets/xmark.svg";
import "../styles/gateway/toasts.css";

export default function ToastStack({ toasts, onDismiss, onPause, onResume }) {
  if (!toasts?.length) return null;
  return (
    <div className="toastStack">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toastItem toast-${toast.type || "info"}${
            toast.closing ? " toastClosing" : ""
          }`}
          onMouseEnter={() => onPause?.(toast.id)}
          onMouseLeave={() => onResume?.(toast.id)}
        >
          <div className="toastContent">
            <div className="toastTitle">{toast.title}</div>
            {toast.message && <div className="toastMessage">{toast.message}</div>}
            {toast.action && (
              <button
                type="button"
                className="toastAction"
                onClick={() => {
                  toast.action.onClick?.();
                  // Action click implies acknowledgement — close the toast.
                  onDismiss?.(toast.id);
                }}
              >
                {toast.action.label}
              </button>
            )}
          </div>
          <button
            type="button"
            className="toastClose"
            onClick={() => onDismiss?.(toast.id)}
            aria-label="Dismiss notification"
          >
            <img className="toastCloseIcon" src={xmarkIcon} alt="" />
          </button>
        </div>
      ))}
    </div>
  );
}
